module.exports = __webpack_public_path__ + "img/settings-services-offered.54fb8c55.svg";